<template>
  <div>
    <ODropdown ref="dropdown" placement="bottom-start">
      <OTooltip :text="$t('general.attach')" placement="top">
        <a class="relative h-8 w-8 flex items-center justify-center rounded-xl cursor-pointer text-gray-600 hover:bg-gray-200 hover:dark:bg-gray-800 dark:text-gray-400">
          <o-icon icon="attachment" />
        </a>
      </OTooltip>

      <template #content>
        <ul class="p-1">
          <li v-for="(option, index) in options" :key="index">
            <a class="flex items-center space-x-3 p-1 transition hover:bg-primary-100 dark:hover:bg-primary-500/20 rounded-xl cursor-pointer" @click="handleActionClick(option)">
              <div class="h-8 w-8 rounded-full bg-primary-100 dark:bg-primary-500/20 flex items-center justify-center text-primary-600">
                <OIcon :icon="option.icon" />
              </div>

              <p class="text-sm opacity-90">
                {{ option.label }}
              </p>
            </a>
          </li>
        </ul>
      </template>
    </ODropdown>

    <div>
      <UploadAttachmentAction ref="uploadAction" :customer="customer" :uploads="uploads" @confirm="handleConfirm" @update:uploads="updateUploads" />
      <ReservationAttachmentAction ref="reservationAction" :customer="customer" @confirm="handleConfirm" />
      <OrderAttachmentAction ref="orderAction" :customer="customer" @confirm="handleConfirm" />
      <CustomerFormAttachmentAction ref="customerFormAction" :customer="customer" @confirm="handleConfirm" />
      <!--<GiftCardAttachmentAction ref="giftCardAction" :customer="customer" @confirm="handleConfirm" />-->
    </div>
  </div>
</template>

<script setup lang="ts">
import UploadAttachmentAction from '@/components/message/elements/attachments/types/upload/Action.vue'
import ReservationAttachmentAction from '@/components/message/elements/attachments/types/reservation/Action.vue'
import OrderAttachmentAction from '@/components/message/elements/attachments/types/order/Action.vue'
import CustomerFormAttachmentAction from '@/components/message/elements/attachments/types/customerForm/Action.vue'
// import GiftCardAttachmentAction from '@/components/message/elements/attachments/types/giftCard/Action.vue'

const { $i18n } = useNuxtApp()

interface Props {
  modelValue?: any[]
  uploads?: Record<string, File>
  customer: Record<string, any>
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
  uploads: () => ({}),
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any[]): void
  (e: 'update:uploads', value: Record<string, File>): void
}>()

const dropdown = ref<any>()
const uploadAction = ref<any>()
const reservationAction = ref<any>()
const orderAction = ref<any>()
const customerFormAction = ref<any>()

const options = [
  {
    label: $i18n.t('components.message.elements.send.attach.attachAsset'),
    icon: 'photos',
    action: () => {
      uploadAction.value.open()
    },
  },
  {
    label: $i18n.t('general.appointment'),
    icon: 'reservation',
    action: () => {
      reservationAction.value.open()
    },
  },
  {
    label: $i18n.t('general.sale'),
    icon: 'order',
    action: () => {
      orderAction.value.open()
    },
  },
  {
    label: $i18n.t('general.form'),
    icon: 'forms',
    action: () => {
      customerFormAction.value.open()
    },
  },
]

const handleActionClick = (option: any) => {
  dropdown.value.close()
  option.action()
}

const handleConfirm = (attachments: any[]) => {
  emit('update:modelValue', [...props.modelValue, ...attachments])
}

const updateUploads = (uploads: Record<string, File>) => {
  emit('update:uploads', uploads)
}
</script>
